export default "__VITE_PUBLIC_ASSET__e01a4825__"